import Parallax, {handleScrolling} from './libs/parallax'
import './libs/lite-youtube'

if (document.querySelector('[data-parallax]')) {
  window.addEventListener('scroll', handleScrolling);
}


// smooth scroll
const scrollFunc = element => {
  element.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector(element.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
};

const navLinks = document.querySelectorAll('.resources-nav a');
navLinks.forEach(scrollFunc);

const toTopLinks = document.querySelectorAll('.back-to-top');
toTopLinks.forEach(scrollFunc);


// Lazy loading images with IntersectionObserver
const initLazyLoading = () => {
  const images = document.querySelectorAll('img[data-src]');
  if (!images.length) return;

  const loadImage = img => {
    const src = img.getAttribute('data-src');
    const card = img.closest('.book-card') || img.parentElement;

    const reveal = () => {
      img.classList.add('is-loaded');
      if (card) {
        card.classList.add('is-loaded');
        card.classList.add('fade-in-up');
      }
    };

    if (!src) {
      reveal();
      return;
    }

    img.addEventListener('load', reveal, { once: true });
    img.addEventListener('error', reveal, { once: true });

    img.src = src;

    // Handle cached images immediately
    if (img.complete && img.naturalWidth > 0) {
      reveal();
    }
  };

  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '100px 0px',
      threshold: 0.05
    });

    images.forEach(img => imgObserver.observe(img));
  } else {
    // Fallback for browsers without IntersectionObserver
    images.forEach(img => loadImage(img));
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLazyLoading);
} else {
  initLazyLoading();
}

